
export const TOKEN_KEY = 'token';
export const USER_ROLE_KEY = 'user-role';
// Use environment variable if available, otherwise fallback to localhost
export const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api`;
